export default class Background {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Background;

		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		self.setBackgroundLeftPosition();

		$(window).on('resize', function() {
			self.setBackgroundLeftPosition();
		});
	}

	setBackgroundLeftPosition() {
		const self = this,
			$content = $('.js-background-content'),
			$background = $('.js-background'),
			leftPos = ($content.length > 0 ? $content.offset().left : 0);

		$background.css({left: leftPos})
	}
}
